import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import notificationReducer, { AppState as NotificationAppState } from './notification/reducer';
import avatarReducer, { AppState as AvatarAppState } from './avatars/reducer';
import { sessionReducer, ISessionAppState } from './session/reducer';
import notificationActions from './notification/actions';
import { sessionActions } from './session/actions';

const REDUX_STATE_KEY = 'reduxState';

export interface ApplicationState {
  session: ISessionAppState
  notification: NotificationAppState,
  avatars: AvatarAppState
}

const stateFromStorage: string|null = sessionStorage.getItem(REDUX_STATE_KEY);

export const store = configureStore<ApplicationState>({
  reducer: {
    session: sessionReducer,
    notification: notificationReducer,
    avatars: avatarReducer,
  },
  preloadedState: stateFromStorage ? JSON.parse(stateFromStorage) as ApplicationState : undefined
});

// Uncomment for debug:
// store.subscribe(() => console.log(store.getState()));
store.subscribe(() => {
  const state = {
    ...store.getState(),
    avatars: { cache: [] }, // Don't store the avatars on reloads
  };
  sessionStorage.setItem(REDUX_STATE_KEY, JSON.stringify(state));
});

export function clearStore(): void {
  store.dispatch(notificationActions.reset());
  store.dispatch(sessionActions.clearDossier());
  store.dispatch(sessionActions.clearUser());
  sessionStorage.removeItem(REDUX_STATE_KEY);
}

export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
